import { nullFn } from '@op/util'
import { componentResolver } from '../../components'
import { resolveBaseLocatorPage } from './resolveBaseLocatorPage'

export const LocatorBasePage = /*@__PURE__*/ componentResolver(resolveBaseLocatorPage, nullFn)
